import React, { useCallback } from 'react';
import i18n from '../../../../i18n';
import { Box, Grid, Hidden } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Icon } from 'components/Icon/Icon';
import { LargeButton, LargeButtonColor } from 'components/LargeButton/LargeButton';
import { SuccessPage } from 'components/SuccessPage/SuccessPage';
import { Text, TextTypography } from 'components/Text/Text';

import { ReactComponent as CheckIcon } from 'assets/glyphs/check-circle.svg';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/main-16/arrow-sort-down--16.svg';
import { ReactComponent as LogoVertical } from 'assets/logo-vertical.svg';

import { RoutePath } from 'RoutePath';

const useStyles = makeStyles(theme => ({
    contents: {
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'flex-end',
    },
    checkIcon: {
        color: '#31D756',
        marginBottom: theme.spacing(3),
    },
    title: {
        marginBottom: theme.spacing(2),
    },
    description: {
        maxWidth: 340,
    },
    footer: {
        flex: 1,
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(1.5),
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'space-between',
        },
    },
    addCardPrompt: {
        margin: 'auto',
        maxWidth: 340,
    },
    arrowIcon: {
        marginBottom: theme.spacing(3.25),
    },
    footerButton: {
        margin: 'auto',
        width: 340,
        paddingBottom: theme.spacing(1),
        [theme.breakpoints.down(480)]: {
            width: '100%',
        },
    },
}));

export const SuccessForm = () => {
    const { t } = i18n.useTranslation();

    const handleStartClick = useCallback(() => {
        window.location.assign(RoutePath.REGISTRATION);
    }, []);

    const classes = useStyles();
    return (
        <SuccessPage>
            <Hidden xsDown>
                <Box m={2} textAlign="center">
                    <LogoVertical />
                </Box>
            </Hidden>
            <div className={classes.contents}>
                <Icon className={classes.checkIcon} component={CheckIcon} size={64} svgSize={32} />
                <Text className={classes.title} typography={TextTypography.DISPLAY_STRONG}>
                    {t('auth:signup.success.title')}
                </Text>
                <Text className={classes.description} component="div" typography={TextTypography.PARA}>
                    {t('auth:signup.success.description')}
                </Text>
            </div>
            <Grid container direction={'column'} justify={'flex-end'} alignItems={'center'} className={classes.footer}>
                <Grid>
                    <Text className={classes.addCardPrompt} component="div" typography={TextTypography.PARA}>
                        {t('auth:signup.success.addCardPrompt')}
                    </Text>
                    <Icon className={classes.arrowIcon} component={ArrowDownIcon} size={16} svgSize={16} />
                    <div className={classes.footerButton}>
                        <LargeButton onClick={handleStartClick}>{t('auth:signup.success.addCardButton')}</LargeButton>
                    </div>
                </Grid>
                <Grid>
                    <div className={classes.footerButton}>
                        <LargeButton onClick={handleStartClick} color={LargeButtonColor.TRANSPARENT}>
                            {t('auth:signup.success.accountButton')}
                        </LargeButton>
                    </div>
                </Grid>
            </Grid>
        </SuccessPage>
    );
};
